import _ from 'underscore';
import ImageLayer from 'ol/layer/Image.js';
import Static from 'ol/source/ImageStatic.js';
import { attributionHtml }  from '../../map/projection.js';

export default class Floors {

	  constructor(floors, floorTile, currentFloor,projection,imageSize,extent) {

    	 this.name = 'Floors';
       this.floors = floors;
       this.projection = projection;
       this.extent = extent;
       this.imageSize = imageSize;
       this.floor = currentFloor;
       this.floorTileSource;
       this.floorTile = floorTile;
       this.floorMap = new Map();
       var _this = this;
       _(floors).each(function(floor){
          _this.floorMap.set(floor.value,floor);
       }); 

  	}

  	toString() {
        return this.name;
    }

  	init() {
      var floor = this.floorMap.get(this.floor);
      this.floorTileSource = new ImageLayer({
              title: floor.label,
              displayInLayerSwitcher: false,
              tileId : floor.value,
              source: new Static({
                  attributions: attributionHtml(),
                  url: this.floorTile,
                  imageSize: this.imageSize,
                  projection: this.projection,
                  imageExtent: this.extent,
              })
          });

  	}

  	getFloors() {
      return this.floors;
  	}

    getFloor(floorIdentifier) {
      return this.floorMap.get(floorIdentifier);
    }

    getTileSource(){
      return this.floorTileSource;
    }


}